export const GET_LESSON_SCORES_REQUEST = 'CERTIFICATES.GET_LESSON_SCORES_REQUEST';
export const GET_LESSON_CERTIFICATES_REQUEST = 'CERTIFICATES.GET_LESSON_CERTIFICATES_REQUEST';
export const GET_LESSON_CERTIFICATES_SUCCESS = 'CERTIFICATES.GET_LESSON_CERTIFICATES_SUCCESS';
export const GET_LESSON_CERTIFICATES_ERROR = 'CERTIFICATES.GET_LESSON_CERTIFICATES_ERROR';
export const SET_LESSON_SCORES = 'CERTIFICATES.SET_LESSON_SCORES';
